<template>
  <div >
    <div style="margin: 10px"></div>
     <h1 class = "test">Weight Ticket</h1>
      <h1 class = "heading1 center">Transfer Ticket Form</h1>
   
   
        <div class = "cl">
            <div >Gross Weight: </div>
            <div>
                <md-field>
                    <md-input v-model="data"
                    disabled/>
                </md-field>
            </div>
        </div>
      

        <div class = "cl">
            <div >Date: </div>
            <div>
                <md-field>
                    <md-input v-model="data"
                    disabled/>
                </md-field>
            </div>
        </div>


        <div class = "cl">
            <div >WT Ticket: </div>
            <div>
                <md-field>
                    <md-input v-model="data"
                    disabled/>
                </md-field>
            </div>
        </div>


        <div class = "cl">
            <div >Trailer: </div>
            <div>
                <md-field>
                    <md-input v-model="data"
                    disabled/>
                </md-field>
            </div>
        </div>

        <div class = "cl">
            <div >Driver: </div>
            <div>
                <md-field>
                    <md-input v-model="data"
                    disabled/>
                </md-field>
            </div>
        </div>

        <div class = "cl">
            <div >Phone #: </div>
            <div>
                <md-field>
                    <md-input v-model="data.driverPh"
                    disabled/>
                </md-field>
            </div>
        </div>

      
  </div>
</template>

<style scoped>
.cl {
    padding-left: 40%;
     padding-right: 40%;
   
}

.heading1 {
    padding-top: 30px;
    padding-left: 0px;
    margin-bottom: 0;
    color: #555555;
    width: 92%;
    line-height: 3;
    font-size: 24px;
    font-family: Roboto Slab;
    margin: auto;
  }

.center {
  margin: auto;
  width: 80%;
  padding: 10px;
}

.sameLine {
    display: inline-block !important;
}


.block_container
{
    text-align:left;
    padding-left: 20%;
}

.layout1 {
    padding-bottom: 1px;
    width: 92%;
    line-height: 1.5;
    color: #555555;
  
    font-family: Roboto Slab;
    margin: auto;
  }



.bloc
{
    display:inline-block;
    font-size: 20px;
    
   
    
}


.layoutHalf1{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 15px;
  }




.md-field{
    display: inline-block !important;
    width: auto;
    margin-bottom: 10px;
    padding-top:10px;
}

.md-field .md-input {
    font-size: 20px !important;
}

.test {
  font-size: 50px;
}
  

</style>


<script>
/* eslint-disable no-plusplus */
import WindowPortal from '../components/WindowPortal.vue';


  export default {
    props: {
        data:String,
    },


    computed: {
        getData() {
        return this.data;
      },
    },
  }

</script>
